<template>
  <div class="outer">
    <div class="video-wrap" ref="videoWrap">

      <video
        preload loop controls muted playsinline
        webkit-playsinline="true"
        x5-video-player-type="h5"
        :src="url"
        ref="video"
      >
      </video>
      <!--<video
        preload autoplay loop controls muted playsinline
        webkit-playsinline="true"
        x5-video-player-type="h5"
        :src="url"
        ref="video"
      >
      </video>-->

      <div class="back-btn" @click="goBack"><van-icon ref="backBtn" class="backBtn" name="arrow-left" color="#ffffff"/></div>

      <div class="toShapeSparkBtn" ref="toShapeSparkBtn" v-if="shapeSparkUrl">
        <img ref="btnImg" src="../../assets/img/ic_HouseCaseDetail_3d.png" alt="3D漫游" @click="toShapeSparkRoam(shapeSparkUrl)">
      </div>

      <div ref="btnWrapper" class="btn-wrapper">
        <div class="btn more"><img @click="toProgramList" ref="more" src="@/assets/img/video/more.png" alt="更多方案"></div>
        <div class="btn skip"><img @click="toProductList" ref="skip" src="@/assets/img/video/check_price.png" alt="查看报价"></div>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: "Video",
  data(){
    return{
      url: '',
      shapeSparkUrl: '',

      id: undefined,          // 具体门牌号
      house_id: undefined,    // 户型id
      program_id: undefined,  // 装修方案id

      REM_RATE: 50,           // rem px 比率
    }
  },
  mounted() {
    // video 为视频链接
    // shapespark_url 为当前方案的ShapeSpark地址
    // title 为当前页面标题目 (当前方案名称)
    // id或者house_id 用于获取方案列表
    // program_id 用于获取当前方案的商品列表
    // config_name_data 地址和门牌号

    let { video, shapespark_url, title , id, house_id, program_id, config_name_data} = this.$route.query

    this.url = video
    this.shapeSparkUrl = shapespark_url
    this.id = id
    this.house_id = house_id
    this.program_id = program_id
    this.config_name_data = config_name_data

    window.document.title = title

    let angle = this.getDeviceAngle()
    if(angle === 90){
      this.resizeVideo90()
    }else if(angle === 0){
      this.resizeVideo()
    }

    let evt = "onorientationchange" in window ? "orientationchange" : "resize"
    window.addEventListener(evt, this.rotate)
  },
  methods:{

    toProgramList(){
      let {id, house_id} = this

      let param = id ? 'id='+id : (house_id ? 'house_id='+house_id : '')

      if(param){
        this.navigateTo('HouseCaseList?'+param)
      }else {
        this.$uihelper.toast('没有更多方案')
      }
    },
    toProductList(){
      let {program_id} = this

      if(program_id){
        this.navigateTo('HouseCaseDetail?program_id='+program_id+'&config_name_data='+this.config_name_data)
      }else {
        this.$uihelper.toast('没有该方案详情')
      }

    },

    toShapeSparkRoam(url){
      document.location.href = url
    },
    getDeviceAngle(){
      try{
        var angle = screen.orientation.angle
      }catch (e){
        var angle = window.orientation
      }
      return angle
    },
    rotate(e){
      try{
        var angle = e.path[0].orientation
      }catch (e){
        var angle = this.getDeviceAngle()
      }
      let deg = Math.abs(angle)

      console.log('deg', deg)

      if(deg === 90){
        this.resizeVideo90()
      }else if(deg === 0){
        this.resizeVideo()
      }
    },
    restoreStyle(){
      let {videoWrap, toShapeSparkBtn} = this.$refs
      videoWrap.style.top = '50%'
      videoWrap.style.transform = 'translate(-50%, -50%) rotate(90deg)'
      if(toShapeSparkBtn) toShapeSparkBtn.style.transform = 'none'
    },

    // 横屏
    resizeVideo(){
      let vw = document.body.clientWidth
      let vh = document.body.clientHeight

      if(vw > vh) [vw, vh] = [vh, vw]

      let {video, videoWrap, toShapeSparkBtn, btnImg, more, skip, btnWrapper, backBtn} = this.$refs
      console.log(backBtn)

      let whRate = video.offsetWidth / video.offsetHeight

      this.restoreStyle()

      if(video.offsetWidth*.87 > vh){
        video.style.width = vh + 'px'
        video.style.height = vh*whRate/3.5 + 'px'

        videoWrap.style.width = vh + 'px'
        videoWrap.style.height = vh*whRate/3.5 + 'px'

        if(toShapeSparkBtn){
          toShapeSparkBtn.style.left = vh*whRate/2.5 + 'px'
          toShapeSparkBtn.style.width = vh*whRate/16 + 'px'
        }

        backBtn.style.fontSize = .45*this.REM_RATE + 'px'
        if(btnImg) btnImg.style.width = vh/10 + 'px'

        more.style.width = 3*this.REM_RATE + 'px'
        skip.style.width = 3*this.REM_RATE + 'px'

        btnWrapper.style.bottom = .7*this.REM_RATE + 'px'
        btnWrapper.style.right = this.REM_RATE + 'px'
      }
    },

    // 竖屏
    resizeVideo90(){
      let vw = document.body.clientWidth
      let vh = document.body.clientHeight

      if(vw > vh) [vw, vh] = [vh, vw]

      let {video, videoWrap, toShapeSparkBtn, btnImg, more, skip, btnWrapper, backBtn} = this.$refs

      video.style.height = vw + 'px'

      videoWrap.style.height = vw + 'px'
      videoWrap.style.top = '0'
      videoWrap.style.left = '50%'
      videoWrap.style.transform = 'translate(-50%)'

      if(toShapeSparkBtn){
        toShapeSparkBtn.style.left = '80%'
        toShapeSparkBtn.style.transform = 'translate(-1%, -50%)'
      }

      backBtn.style.fontSize = .45*this.REM_RATE + 'px'
      if(btnImg) btnImg.style.width = vh/10 + 'px'

      more.style.width = 2.3*this.REM_RATE + 'px'
      skip.style.width = 2.3*this.REM_RATE + 'px'

      btnWrapper.style.bottom = .7*this.REM_RATE + 'px'
      btnWrapper.style.right = this.REM_RATE + 'px'
    }
  }
}
</script>

<style lang='scss' scoped>
@import "video";
</style>
